import { ProductCardTemplate } from 'components/UI/ProductCard';
import { memo } from 'react';
import { ModesProps } from '../props';

function ListAtomic(props: ModesProps) {
  return (
    <ProductCardTemplate
      variant="list"
      product={props.product}
      packingSelected={props.packingSelected}
      onSelectPacking={props.handleOnSelectPacking}
      getLowPrice={props.getLowPrice}
      addInCart={props.addInCart}
      selectedTypeSale={props.selectedTypeSale}
      buy={props.buy}
      showModalComposition={props.showModalComposition}
      isExclusiveOffer={props.isExclusiveOffer}
    />
  );
}

export default memo(ListAtomic);
